/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    inline: PropTypes.bool,
    disabled: PropTypes.bool,
    color: PropTypes.oneOf([
        'light',
        'white',
        'error',
    ]),
};

const defaultProps = {
    ...commonDefaultProps,
    componentClass: 'a',
    inline: false,
    disabled: false,
};

const Link = (props) => {
    const classNames = [
        'c-link',
        props.color === 'error' ? 'c-link--error' : '',
        props.color === 'light' ? 'c-link--light' : '',
        props.color === 'white' ? 'c-link--white' : '',
        props.inline ? 'c-link--inline' : '',
        props.disabled ? 'c-link--disabled' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

Link.propTypes = propTypes;

Link.defaultProps = defaultProps;

export default Link;
